import React from "react";
import { Select, Spin, Typography } from "antd";
import { formatMoney } from "utils";

export const CompanyBalance = ({ balance }) => {
    if (!balance) {
        return null;
    }
    return (
        <Typography.Text type="secondary">
            {balance.loading ? <Spin size="small" /> : `Saldo: ${formatMoney(balance.value)}`}
        </Typography.Text>
    );
};

export const InternalTransferCompanySelect = (props) => {
    const { companies, excludeId, value, onChange, balance, placeholder, disabled } = props;
    return (
        <>
            <Select
                style={{ width: "100%" }}
                showSearch
                optionFilterProp="label"
                placeholder={placeholder}
                disabled={disabled}
                value={value}
                onChange={onChange}
                options={companies
                    .filter((company) => company.id !== excludeId)
                    .map((company) => ({ value: company.id, label: company.fantasyName }))}
            />
            <CompanyBalance balance={balance} />
        </>
    );
};
